import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TSvgIconProps } from '../icon.component';

const PdsPosventa = forwardRef(
  ({ ...props }: TSvgIconProps, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        preserveAspectRatio="none"
        viewBox="0 0 32 32"
        ref={ref}
        xmlSpace="preserve"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M3.34003 16.1205L2.83681 15.8638C1.97141 15.4222 1.54848 14.4226 1.8342 13.4941L3.34003 8.6001L15.59 14.8501V29.1001L5.113 23.7547C4.02494 23.1995 3.34003 22.0812 3.34003 20.8597V16.1205Z"
          fill="white"
        />
        <path
          d="M9.87922 5.26361L15.5 8.13284L21.3024 5.26446L27.84 8.59996L15.59 14.85L3.33997 8.59996L9.87922 5.26361Z"
          fill="#CAB4FF"
        />
        <path
          d="M27.8401 8.6001L15.5901 14.8501V28.8501L26.0671 23.5047C27.1552 22.9495 27.8401 21.8312 27.8401 20.6097V8.6001Z"
          fill="#CAB4FF"
        />
        <path
          d="M9.3717 5.00452L15.5 8.13282L21.8282 5.00452L15.5 1.6781L9.3717 5.00452Z"
          fill="#EDE8FF"
        />
        <path d="M9 5.53003L15.5 8.53003V15.03L9 12.03V5.53003Z" fill="white" />
        <path
          d="M28.3433 15.8638L19.7105 20.2682C18.6038 20.8329 17.2554 20.2624 16.89 19.0749L15.5901 14.8501L27.8401 8.6001L29.3459 13.4941C29.6316 14.4226 29.2087 15.4222 28.3433 15.8638Z"
          fill="#EDE8FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.5897 5.07936C22.3745 4.4359 21.914 3.88903 21.2897 3.57161L16.7897 1.28372C16.0421 0.903636 15.1579 0.903636 14.4104 1.28372L9.91037 3.57161C9.29001 3.88701 8.83141 4.42895 8.6145 5.0671L2.99924 7.93203C2.81279 8.02716 2.67764 8.19394 2.62041 8.38892L1.11746 13.2735C0.724605 14.5503 1.30613 15.9247 2.49606 16.5318L11.1288 20.9363C12.5139 21.643 14.1742 21.0567 14.8401 19.7145V28.8501C14.8401 29.2643 15.1759 29.6001 15.5901 29.6001C16.0043 29.6001 16.3401 29.2643 16.3401 28.8501V19.7145C17.0061 21.0567 18.6663 21.643 20.0514 20.9363L28.6842 16.5318C29.8741 15.9247 30.4556 14.5503 30.0628 13.2735L28.5585 8.38449C28.554 8.36959 28.549 8.35486 28.5437 8.34031C28.5061 8.23852 28.4472 8.14706 28.3721 8.07143C28.3424 8.04152 28.3101 8.01409 28.2756 7.98948C28.2457 7.96814 28.214 7.94892 28.1809 7.93203M21.475 11.0056L16.225 13.6842V8.89062C16.4187 8.84315 16.6082 8.77328 16.7897 8.68102L21.475 6.2989V11.0056ZM22.725 10.3678L26.1898 8.6001L22.725 6.83236V10.3678ZM27.3858 9.67387L16.4922 15.2318L17.6069 18.8543C17.8352 19.5965 18.678 19.9531 19.3697 19.6002L28.0025 15.1957C28.5433 14.9197 28.8077 14.295 28.6291 13.7146L27.3858 9.67387ZM3.79444 9.67389L14.688 15.2318L13.5734 18.8543C13.345 19.5965 12.5023 19.9531 11.8106 19.6002L3.17777 15.1957C2.63689 14.9197 2.37256 14.295 2.55113 13.7146L3.79444 9.67389ZM4.99039 8.60009L8.47504 10.378V6.82221L4.99039 8.60009ZM9.72504 6.29891V11.0157L14.975 13.6943V8.89062C14.7814 8.84315 14.5918 8.77328 14.4104 8.68102L9.72504 6.29891ZM16.2232 2.39798C15.8316 2.19888 15.3685 2.19888 14.9769 2.39798L10.4769 4.68587C10.2998 4.77589 10.1479 4.90116 10.0279 5.05061L14.9769 7.56676C15.3685 7.76585 15.8316 7.76585 16.2232 7.56676L21.1722 5.05061C21.0522 4.90115 20.9003 4.77589 20.7232 4.68587L16.2232 2.39798Z"
          fill="#000083"
        />
        <path d="M28.178 7.93051L22.5897 5.07936Z" fill="#000083" />
        <path
          d="M3.68094 7.93203C3.44844 7.8134 3.17098 7.82419 2.94839 7.96051C2.72579 8.09683 2.59009 8.33908 2.59009 8.6001V11.0376L3.34009 8.6001L15.5901 14.8501L15.3695 15.5669C15.5132 15.6112 15.667 15.6112 15.8107 15.5669L15.5901 14.8501L27.8401 8.6001L28.5901 11.0376V8.6001C28.5901 8.33908 28.4544 8.09683 28.2318 7.96051C28.0092 7.82419 27.7317 7.8134 27.4992 7.93203L15.5901 14.0081L3.68094 7.93203Z"
          fill="#000083"
        />
        <path
          d="M27.0901 18.0805V16.5032L28.3433 15.8638C28.4301 15.8195 28.5125 15.7696 28.5901 15.7147V19.4571C28.1658 18.9237 27.6594 18.4584 27.0901 18.0805Z"
          fill="#000083"
        />
        <path
          d="M16.7263 27.8784L18.1294 27.1625C18.4217 27.5903 18.7637 27.9813 19.1471 28.3273L17.408 29.2146C16.2661 29.7972 14.9141 29.7972 13.7722 29.2146L4.77221 24.6227C3.43305 23.9395 2.59009 22.5631 2.59009 21.0597V15.7147C2.66772 15.7696 2.75007 15.8195 2.83687 15.8638L4.09009 16.5032V21.0597C4.09009 21.9993 4.61694 22.8596 5.45391 23.2866L14.4539 27.8784C15.1676 28.2426 16.0126 28.2426 16.7263 27.8784Z"
          fill="#000083"
        />
        <path
          d="M6.12408 20.0434C5.81661 19.8865 5.44018 20.0086 5.28331 20.3161C5.12644 20.6235 5.24852 21 5.55599 21.1568L7.51599 22.1568C7.82346 22.3137 8.19989 22.1916 8.35676 21.8842C8.51364 21.5767 8.39155 21.2003 8.08408 21.0434L6.12408 20.0434Z"
          fill="#000083"
        />
        <path
          d="M31 23.5C31 27.6421 27.6421 31 23.5 31C19.3579 31 16 27.6421 16 23.5C16 19.3579 19.3579 16 23.5 16C27.6421 16 31 19.3579 31 23.5Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.5264 20.9658C27.8215 21.2565 27.825 21.7314 27.5342 22.0264L22.759 26.8726C22.6181 27.0156 22.4256 27.0962 22.2248 27.0962C22.024 27.0962 21.8315 27.0156 21.6906 26.8726L19.4658 24.6147C19.175 24.3197 19.1786 23.8448 19.4736 23.5541C19.7686 23.2634 20.2435 23.2669 20.5342 23.5619L22.2248 25.2776L26.4658 20.9736C26.7565 20.6785 27.2314 20.675 27.5264 20.9658Z"
          fill="white"
        />
      </svg>
    );
  }
);
export default PdsPosventa;
